module.exports = __webpack_public_path__ + "static/home4-aefc5e3837cb49bb35413c540232bdf1.jpg";